export const PaymentEnums = {
  CREDITCARD: "creditcard",
  ONLINEEFTPOS: "onlineeftpos",
  DIRECTDEBIT: "directdebit",
  COMPLIMENTARY: "complimentary",
  AFTERPAY: "afterpay",
  PAYPLAN: "payplan",
} as const;

export const PaymentTypeCodes = {
  BANK_TRANSFER: "BT",
  PAYPLAN: "BNPL-PP",
} as const;

export const ImageFormat = {
  PORTRAIT: "Portait",
  PORTRAITLARGE: "Portrait Large",
  PORTRAITSMALL: "Portrait Small",
  BANNER: "Banner (new)",
  SQUARE: "Square",
  NEWSLETTER: "Newsletter",
} as const;

export const EpassRegoInputType = {
  BLANK: "blank",
  TEXT: "text",
  TEXTAREA: "textarea",
  RADIO: "radio",
  CHECKBOX: "checkbox",
  DATE: "date",
  DATETIME: "datetime",
  DROPDOWN: "dropdown",
} as const;

export const RegoInputType = {
  BLANK: "blank",
  TEXT: "text",
  TEXTAREA: "textarea",
  RADIOBUTTONGROUP: "radiobuttongroup",
  CHECKBOX: "checkbox",
  DATE: "date",
  DATETIME: "datetime",
  DROPDOWN: "dropdown",
} as const;

export const OrderRegoInputType = {
  BLANK: "blank",
  TEXT: "text",
  TEXTAREA: "textarea",
  RADIO: "radio",
  CHECKBOX: "checkbox",
  DATE: "date",
  DATETIME: "datetime",
  DROPDOWN: "dropdown",
} as const;

export const EventMode = {
  LIST: 1,
  CALENDAR: 1,
} as const;

export const ShowingStatus = {
  AVAILABLE: 1,
  SOLDOUT: 2,
  CANCELLED: 3,
  POSTPONED: 4,
  NOTYETONSALE: 5,
  ADMINSOLDOUT: 6,
  FREEENTRY: 7,
} as const;

export const ShowingGroupMode = {
  GROUPED: 1,
  UNGROUPED: 2,
} as const;

export const AccessType = {
  PUBLIC: "public",
  NOTYETONSALE: "notyetonsale",
  NOTONSALE: "notonsale",
  DOORSALES: "doorsales",
  SALESCLOSED: "salesclosed",
  PASSWORD: "password",
  EXPIRED: "expired",
} as const;

/**
 * Maps to BookingAvailabilityStatusType on the C# backend.
 * Values must stay in sync with that enum.
 */
export enum PriceStatus {
  // ── Legacy states ──────────────────────────────────────────────────────────
  NOTAVAILABLE = 0,
  AVAILABLE = 1,
  SOLDOUT = 2,
  BOOKEDOUT = 3,
  LIMITREACHED = 4,

  // ── New GA release states ──────────────────────────────────────────────────
  // Non-contiguous with legacy block to avoid accidental collisions.

  /** On-sale window hasn't opened yet. Check `availableFrom` for the date. */
  UPCOMING = 10,
  /** Locked until a trigger area (e.g. "First Release") sells out. */
  AWAITINGTRIGGER = 11,
  /** On-sale window has closed, or channel cutoff has passed. Filtered out before display. */
  ENDED = 12,
}

export const OrderStatus = {
  AWAITING: "Awaiting payment",
  COMPLETE: "Complete",
  IN_REVIEW: "IN REVIEW",
  ON_HOLD: "ON HOLD",
  PAYPLANACTIVE: "PAYPLAN ACTIVE",
} as const;

export const PaymentStatus = {
  PAY_AT_VENUE: "PAY AT THE VENUE",
  PAID: "PAID",
  UNPAID: "UNPAID",
  PENDING: "PENDING",
  INCOMPLETE: "Incomplete",
  DEPOSITPAID: "DEPOSIT PAID",
} as const;

export const PaymarkEvents = {
  SUBMITTED: "payment_submitted",
  CHALLENGED: "payment_challenged",
  ID_UPDATED: "payment_id_updated",
  SUBMISSION_RESPONSE: "payment_submission_response",
  CHALLENGED_RESPONSE: "payment_challenge_response",
  INPUT: "payment_input",
  EXPIRED: "payment_expired",
  INVALID: "payment_id_invalid",
} as const;

export const TicketShareStatus = {
  PENDING: 1,
  SUCCESS: 2,
  DECLINED: 3,
  WITHDRAWN: 4,
  EXPIRED: 5,
} as const;

export const TicketStatus = {
  CANCELLED: 10,
} as const;

export const AnalyticsTypeEnum = {
  GA4: "ga4",
  METAPIXEL: "metapixel",
} as const;

export const CardBrandNames: { [key: string]: string } = {
  amex: "American Express",
  visa: "Visa",
  mastercard: "MasterCard",
};
